import React from "react";
import { Modal } from "react-bootstrap";
import { ThreeDots } from "react-loader-spinner";

export const ReactLoaderSpinner = () => {
  return (
    <Modal
      show={true}
      fullscreen={true}
      backdrop="static"
      keyboard={false}
      enforceFocus={true}
      style={{ opacity: 0.8 }}
    >
      <Modal.Body
        style={{
          position: "absolute",
          top: "35%",
          left: "50%",
        }}
      >
        <ThreeDots
          visible={true}
          height="90"
          width="90"
          color="#039b96"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </Modal.Body>
    </Modal>
  );
};
